{
  "$id": "http://softball.app/schemas/team-read-only",
  "title": "Team - Read Only",
  "type": "object",
  "required": [],
  "properties": {
    "publicIdEnabled": {
      "type": "boolean",
      "description": "Whether or not the stats for the team should be available at a public web address"
    },
    "publicId": {
      "type": "string",
      "description": "The unique identifier used to construct the public web address for this teams stats (if enabled)"
    }
  }
}
